<template>
  <div>
    <scale-box :width="1578" :height="780" bgc="transparent" :delay="10" :isFlat="false">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </scale-box>

    <update-dialog></update-dialog>
  </div>
</template>

<script>
import UpdateDialog from "@/components/UpdateDialog.vue";
import { mapMutations, mapState } from "vuex";
import ScaleBox from "vue2-scale-box";

export default {
  components: {
    ScaleBox,
    UpdateDialog
  },
  data() {
    return {
      socket: null,
    };
  },
  computed: {
    ...mapState({
      ws: (state) => state.ws.ws,
    }),
  },
  mounted() {
    // this.initWebSocket();
  },
  beforeDestroy() {
    this.closeWebSocket();
  },
  methods: {
    ...mapMutations("ws", ["setWs"]),
    initWebSocket() {
      // 初始化WebSocket连接
      this.socket = new WebSocket("ws://127.0.0.1:8000/chat");
      this.setWs(this.socket);

      // 监听WebSocket连接打开事件
      this.ws.onopen = () => {
        console.log("WebSocket onopen");
      };

      // 监听WebSocket接收到消息事件
      this.ws.onmessage = (event) => {
        console.log("Received message:", event.data);
      };

      // 监听WebSocket连接关闭事件
      this.ws.onclose = () => {
        console.log("WebSocket closed");
      };

      // 监听WebSocket发生错误事件
      this.ws.onerror = (error) => {
        console.error("WebSocket error:", error);
      };
    },
    closeWebSocket() {
      // 关闭WebSocket连接
      if (this.ws) {
        this.ws.close();
      }
    },
  },
};
</script>

<style>
body,
html {
  width: 100%;
  height: 750px;
  overflow: scroll;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

img {
  width: 100%;
  height: 100%;
}

/* .el-dialog {
  display: flex;
  justify-content: center;
  align-items: center;
} */

::-webkit-scrollbar {
  width: 7px;
  height: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c0c0c0;
  border-radius: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

scrollbar {
  -moz-appearance: none;
  width: 12px;
  height: 12px;
}

scrollbar-thumb {
  background: #c0c0c0;
  border-radius: 6px;
}

scrollbar-track {
  background: #f1f1f1;
}

.custom-alert {
  /* 弹窗主体样式 */
  width: 650px !important;
  /* 弹窗宽度 */
  border-radius: 10px !important;
  /* 圆角边框 */
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
  /* 阴影效果 */
  padding: 20px !important;
  /* 内边距 */
  background: #ffffff !important;
  /* 背景色 */
}

.custom-alert .el-message-box__message p {
  line-height: 30px !important;
  /* 行高 */
}
</style>
